var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content queryInvoice" },
    [
      _c(
        "search-item",
        {
          key: _vm.identify,
          ref: _vm.identify,
          attrs: {
            "show-more-scheme": true,
            "show-simple": _vm.showSimple,
            "expand-adv": true,
            "auto-init": _vm.searchItemAutoInit,
            "custom-search-items": _vm.customSearchItems,
            "is-simple-query": _vm.isSimpleQuery,
            "custom-sim-query-placeholder": _vm.customSimQueryPlaceholder,
            "config-module": _vm.configModule,
            "col-settings": _vm.colSettings
          },
          on: {
            "update:isSimpleQuery": function($event) {
              _vm.isSimpleQuery = $event
            },
            "update:is-simple-query": function($event) {
              _vm.isSimpleQuery = $event
            },
            query: _vm.queryBtnClickHandler,
            advToggle: _vm.scrollCallback
          }
        },
        [
          _c("template", { slot: "operations" }, [_vm._t("operations")], 2),
          _c(
            "template",
            { slot: "searchAreaHeader" },
            [_vm._t("searchAreaHeader")],
            2
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "min-height": _vm.hasVoucher === 0 ? "350px" : "200px"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-wrapper",
          attrs: { id: "footer-wrapper-tab-actualamount" }
        },
        [
          _vm.showChargeCurrencyTotalGroup
            ? _c(
                "div",
                {
                  class: [_vm.shouldFixed ? "fixedBottom" : ""],
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap",
                    "margin-top": "5px"
                  }
                },
                [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.dataShow &&
                          _vm.totalAmountToCurrency.selectionCountLabel,
                        expression:
                          "dataShow && totalAmountToCurrency.selectionCountLabel"
                      }
                    ],
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrency.selectionCountLabel
                      )
                    }
                  }),
                  _vm.reCalc
                    ? _c("charge-currency-total-group", {
                        attrs: {
                          "ar-field": "ar",
                          "currency-field": "currency",
                          "data-field": "amount",
                          "amount-to-currency": _vm.localCurrency,
                          "rate-field": "rate",
                          type: "revenueAbs",
                          "amount-to-currency-label": _vm.$t("Message.Convert"),
                          "data-provider":
                            _vm.totalAmountToCurrency.dataProvider,
                          "arap-group": _vm.arapGroup
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c("cargo-pagination", {
            attrs: {
              "config-module": _vm.gridConfigModule,
              total: _vm.pageConditions.total,
              page: _vm.pageConditions.pageNum,
              limit: _vm.pageConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pageConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.pageConditions, "pageSize", $event)
              },
              pagination: _vm.query
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }